import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import { validateEmail } from '../../../../helpers/authValidation';
import RoleService from '../../../../services/RoleService/RoleService';
import UserService from '../../../../services/UserService/UserService';
import FormInputs from '../parts/formComponents/FormInputs';
import FormButtons from '../parts/formComponents/FormButtons';
import Validations from '../parts/formComponents/passwordValidations';
import { ADMIN, GUEST, IPAAS_DEV, RPA_DEV } from '../../../../services/config';
import Roles from '../parts/formComponents/Roles';
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../recoil-store/recoil-state';
import '../addNewUser/AddNewUser.css';

function UpdateUserPage(props) {
    let history = useNavigate()
    const params = useParams();
    const paramsId = params.id;
    const { t } = useTranslation();
    // To update message and button
    const [disableCreateButton, setDisableCreateButton] = useState(false);
    // To update TransferList
    const [, setRoleLeft] = useState([]);
    const [isNewRole, setIsNewRole] = useState(false);
    const roleLeft = useRef([]);
    const roleRight = useRef([]);
    const [userType, setUserType] = useState('');
    // To update input values
    const [values, setValues] = useState({
        first_name: '',
        second_name: '',
        last_name: '',
        user_name: '',
        user_email: '',
        confirmEmail: '',
        user_password: '',
        user_password_retry: ''
    });

    const [validations, setValidations] = useState({
        first_name: true,
        last_name: true,
        user_name: true,
        user_email: true,
        confirmEmail: true,
        user_password: true,
        user_password_retry: true
    });

    const [initialValues, setInitialValues] = useState({
        first_name: '',
        second_name: '',
        last_name: '',
        user_name: '',
        user_email: '',
        confirmEmail: '',
        user_password: '',
        user_password_retry: ''
    });

    const [initialRoleRight, setInitialRoleRight] = useState([]);
    const [initialRoleLeft, setInitialRoleLeft] = useState([]);
    const setAlert = useSetRecoilState(alertState);

    useEffect(() => {
        const id = paramsId;
        let initRoles = [];
        UserService.getUserByID(id)
            .then((response) => {
                const initInput = response.data.data;
                const data = {
                    first_name: initInput.first_name ? initInput.first_name : '',
                    second_name: initInput.second_name ? initInput.second_name : '',
                    last_name: initInput.last_name ? initInput.last_name : '',
                    user_name: initInput.user_name,
                    user_email: initInput.user_email ? initInput.user_email : '',
                    confirmEmail: initInput.user_email ? initInput.user_email : '',
                    user_password: '',
                    user_password_retry: ''
                };
                setValues(data);
                setInitialValues(data);
                initRoles = response.data.data.roles;
                setInitialRoleRight(initRoles);

                if (id === ADMIN.ID) {
                    roleRight.current = response.data.data.roles.filter(a => a.role_name !== ADMIN.ROLE_NAME);
                    setUserType(ADMIN.ROLE_NAME);
                } else if (id === GUEST.ID) {
                    roleRight.current = response.data.data.roles.filter(a => a.role_name !== GUEST.ROLE_NAME);
                    setUserType(GUEST.ROLE_NAME);
                } else if (id === IPAAS_DEV.ID) {
                    roleRight.current = response.data.data.roles.filter(a => a.role_name !== IPAAS_DEV.ROLE_NAME);
                    setUserType(IPAAS_DEV.ROLE_NAME);
                } else if (id === RPA_DEV.ID) {
                    roleRight.current = response.data.data.roles.filter(a => a.role_name !== RPA_DEV.ROLE_NAME);
                    setUserType(RPA_DEV.ROLE_NAME);
                } else {
                    roleRight.current = [...response.data.data.roles];
                    setUserType('');
                }

                RoleService.getRoles()
                    .then(response => {
                        const roles = response.data.data.filter((x) => {
                            for (let e of initRoles) { if (e.id === x.id) { return false; } }
                            return true;
                        });
                        setInitialRoleLeft(roles);
                        roleLeft.current = [...roles];
                        setRoleLeft(roles);
                    }).catch(err => {
                        console.log(err);
                    });
            }).catch((error) => {
                console.log(error);
            });
    }, [isNewRole]);

    const handleChange = (name, event) => {
        event.preventDefault();
        let value = event.target.value;
        setValues({ ...values, [name]: value });

        if (name === 'first_name') {
            setValidations(oldState => { return { ...oldState, first_name: value.trim().length > 1 }; });
        } else if (name === 'second_name') {
            setValidations(oldState => { return { ...oldState, second_name: true }; });
            if (value.trim().length === 1) {
                setValidations(oldState => { return { ...oldState, second_name: false }; });
            }
        } else if (name === 'last_name') {
            setValidations(oldState => { return { ...oldState, last_name: value.trim().length > 1 }; });
        } else if (name === 'user_name') {
            setValidations(oldState => { return { ...oldState, user_name: value.trim().length > 1 }; });
        } else if (name === 'user_email') {
            setValidations(oldState => { return { ...oldState, user_email: validateEmail(value) }; });
            setValidations(oldState => { return { ...oldState, confirmEmail: (values.confirmEmail === value) }; });
        } else if (name === 'confirmEmail') {
            setValidations(oldState => { return { ...oldState, confirmEmail: (values.user_email === value) }; });
        } else if (name === 'user_password') {
            let validPassword = Validations.passwordValidations(value);
            if (value.length > 0) { setValidations(oldState => { return { ...oldState, user_password: validPassword }; }); }
            else { setValidations(oldState => { return { ...oldState, user_password: true }; }); }
            setValidations(oldState => { return { ...oldState, user_password_retry: (values.user_password_retry === value) }; });
        } else if (name === 'user_password_retry') {
            setValidations(oldState => { return { ...oldState, user_password_retry: (values.user_password === value) }; });
        }

        setValidations(currentState => { setDisableCreateButton(!Validations.allTrue(currentState)); return currentState; });
    };


    const checkValidForm = () => {
        let isValid = true;
        if (values.first_name.length < 3) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.USER.FIRST-NAME-LENGTH-ERROR'),
                severity: 'error'
            }));
            isValid = false;
        } else if (values.last_name.length < 3) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.USER.LAST-NAME-LENGTH-ERROR'),
                severity: 'error'
            }));
            isValid = false;
        } else if (values.user_name.length < 3) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.USER.USER-NAME-LENGTH-ERROR'),
                severity: 'error'
            }));
            isValid = false;
        }
        return isValid;
    }

    const handleUpdateUser = async (event) => {
        event.preventDefault();
        const id = paramsId;
        const updatingFields = [];

        if (roleRight.current.length || id === ADMIN.ID || id === GUEST.ID || id === IPAAS_DEV.ID || id === RPA_DEV.ID) {
            Object.entries(values).forEach((element) => {
                if (values[element[0]] !== initialValues[element[0]]) {
                    updatingFields.push({ "field_name": element[0], "field_value": element[1] });
                }
            });

            if (updatingFields.length) {
                if (!checkValidForm()) {
                    return;
                }
                const data = {
                    user_id: id,
                    current_user_id: id,
                    updatingFields
                };
                const response = await UserService.updateUser(data);
                if (response) { if (response.status) { updateUserRoles(id, response); } }
                else {
                    setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }));
                }
            } else { updateUserRoles(id, undefined); }
        }
        else {
            setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.USER.MIN-ROLE-ERROR'), severity: 'error' }));
        }
    };

    const updateUserRoles = async (id, userUpdateResponse) => {
        const willBeAddedRole = roleRight.current.reduce((acc, role) => {
            for (let r of initialRoleRight) { if (role.id === r.id) { return acc; } }
            return acc.concat(role.id);
        }, []);
        const willBeDeletedRole = roleLeft.current.reduce((acc, role) => {
            for (let r of initialRoleLeft) { if (role.id === r.id) { return acc; } }
            return acc.concat(role.id);
        }, []);

        if (willBeAddedRole.length || willBeDeletedRole.length) {
            const data = { user_role: [{ userId: id, willBeAddedRole, willBeDeletedRole }] };
            const roleResponse = await RoleService.updateUserRoles(data);
            if (roleResponse) {
                let severity = (userUpdateResponse ? userUpdateResponse.status : roleResponse.status) ? 'success' : 'error'
                setAlert(alert => ({ ...alert, show: true, message: t(`MESSAGES.USER.${userUpdateResponse ? userUpdateResponse.message : roleResponse.message}`), severity: severity }));
                if (roleResponse.status) {
                    setInitialRoleLeft(roleLeft.current);
                    setInitialRoleRight(roleRight.current);
                }
            }
            else {
                setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }));
            }
        }
        else {
            let severity = userUpdateResponse ? (userUpdateResponse.status ? 'success' : 'error') : 'error'
            setAlert(alert => ({ ...alert, show: true, message: t(`MESSAGES.USER.${userUpdateResponse ? userUpdateResponse.message : 'UPDATING-FIELDS-IS-NOT-PROVIDED'}`), severity: severity }));
        }
        history('/management/user-management/users');
    }

    const handleCancel = (event) => {
        setValidations({
            first_name: false,
            last_name: false,
            user_name: false,
            user_email: false,
            confirmEmail: false,
            user_password: false,
            user_password_retry: false
        });
        setValues({
            first_name: '',
            second_name: '',
            last_name: '',
            user_name: '',
            user_email: '',
            confirmEmail: '',
            user_password: '',
            user_password_retry: '',
        });
        setDisableCreateButton(true);
        Validations.passwordValidations('');
    };

    return (
        <div className="addnewuser-container" data-test="addnewuser-page">
            <div><h3>{t('CONTENT.USER.ACCOUNT-INFO')}</h3></div>
            <FormInputs
                data-test="form-inputs"
                handleChange={handleChange}
                values={values} validations={validations}
            />
            <div className="hru-container"></div>
            <div><h3>{t('CONTENT.USER.ROLE-INFO')}</h3></div>
            <Roles roles={roleLeft} rolesChecked={roleRight} userType={userType} setRoleState={setIsNewRole} />
            <FormButtons
                data-test="form-buttons"
                handleCancel={handleCancel}
                handleCreateUser={handleUpdateUser}
                disableCreateButton={disableCreateButton}
                buttonText={t('CONTENT.USER.SAVE-USER')}
            />
        </div>
    );
}
export default UpdateUserPage;